import Cookies from 'js-cookie';

import store from '@core/store/redux';
import UserEntity from '@modules/user/entity';

import profileStore, { setToken } from './profileStore';
import * as authenticationRepository from './repository';

const authenticationPresenter = { ...authenticationRepository };

authenticationPresenter.login = async (code, remember = false) => {
  const token: any = await authenticationRepository.login(code);
  store.dispatch(
    setToken({ token: token.accessToken, refreshToken: token.refreshToken, remember }),
  );
  Cookies.set('accessTokenMtc', token.accessToken);
  return token;
};
authenticationPresenter.resetToken = payload => {
  return authenticationRepository.resetToken(payload).then((res: any) => {
    store.dispatch(profileStore.actions.resetToken(res));
    Cookies.set('accessTokenMtc', res.accessToken);
    return Promise.resolve(res);
  });
};
authenticationPresenter.getProfile = () => {
  return authenticationRepository.getProfile().then((user: UserEntity) => {
    store.dispatch(
      profileStore.actions.fetchProfile({
        user,
        listPermissionCode: user?.role?.permissions?.map(p => p.code),
      }),
    );
    Cookies.set('usernameMtc', user?.username);
    return Promise.resolve(user);
  });
};

export default authenticationPresenter;
